import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useContractLogsList() {
  // Use toast
  const toast = useToast()

  const refContractLogsListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'timestamp', label: '時間', sortable: true, thClass: 'text-nowrap', thStyle: { width: '160px' } },
    { key: 'level', label: '級別', sortable: true, thClass: 'text-center', thStyle: { width: '80px' } },
    { key: 'message', label: '消息', sortable: false, thStyle: { width: '300px' } },
    { key: 'context', label: '詳細信息', sortable: false, thStyle: { width: '200px' } },
    { key: 'actions', label: '操作', thClass: 'text-center', thStyle: { width: '100px' } },
  ]
  const perPage = ref(50)
  const totalContractLogs = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('timestamp')
  const isSortDirDesc = ref(true)

  // 過濾器
  const filterDate = ref('')
  const filterLevel = ref(null)
  const levelOptions = [
    { label: '全部', value: null },
    { label: '資訊', value: 'info' },
    { label: '警告', value: 'warning' },
    { label: '錯誤', value: 'error' },
  ]

  // 統計數據
  const stats = ref({})

  // 詳情彈窗
  const showDetailModal = ref(false)
  const selectedLog = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refContractLogsListTable.value ? refContractLogsListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalContractLogs.value,
    }
  })

  const refetchData = () => {
    refContractLogsListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, filterDate, filterLevel], () => {
    refetchData()
  })

  const fetchContractLogs = (ctx, callback) => {
    store
      .dispatch('app-contract-logs/fetchContractLogs', {
        page: currentPage.value,
        per_page: perPage.value,
        search: searchQuery.value,
        date: filterDate.value,
        type: filterLevel.value,
      })
      .then(response => {
        const { data, pagination } = response.data
        callback(data)
        totalContractLogs.value = pagination.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: '錯誤',
            icon: 'AlertTriangleIcon',
            text: '無法獲取合約日誌數據',
            variant: 'danger',
          },
        })
      })
  }

  const fetchStats = () => {
    store
      .dispatch('app-contract-logs/fetchStats')
      .then(response => {
        stats.value = response.data.data
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: '錯誤',
            icon: 'AlertTriangleIcon',
            text: '無法獲取統計數據',
            variant: 'danger',
          },
        })
      })
  }

  const resetFilters = () => {
    filterDate.value = ''
    filterLevel.value = null
    searchQuery.value = ''
    currentPage.value = 1
  }

  const showLogDetail = (log) => {
    selectedLog.value = log
    showDetailModal.value = true
  }

  return {
    fetchContractLogs,
    fetchStats,
    tableColumns,
    perPage,
    currentPage,
    totalContractLogs,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refContractLogsListTable,

    filterDate,
    filterLevel,
    levelOptions,
    resetFilters,

    stats,

    showDetailModal,
    selectedLog,
    showLogDetail,

    refetchData,
  }
}